
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M46.473 2.829A2.834 2.834 0 0043.633 0H37.97a2.834 2.834 0 00-2.837 2.829v42.382h11.333V2.829zM31.736 19.785a2.834 2.834 0 00-2.84-2.829h-5.663a2.834 2.834 0 00-2.837 2.829v25.426h11.333V19.785zM16.998 36.734a2.834 2.834 0 00-2.833-2.829H8.502a2.834 2.834 0 00-2.837 2.829v8.478h11.333v-8.478zM50.282 48.605H1.7a1.7 1.7 0 100 3.394h48.59a1.7 1.7 0 10-.008-3.394z"}})])])
          )
        }
      }
    